'use strict';

var cssBreakpoints = require('bunsen/json/breakpoints.json');
var breakpoints;
var props;

/**
 * Create a consistent return signature
 * @type {{integer: {}, pixel: {}, catchError: boolean}}
 */
breakpoints = {
    integer: {},
    pixel: {},
};

/**
 * Create an object of pixel and integer values
 * @param {object} obj The object of values to parse
 * @returns {{pixel: {}, integer: {}}}
 */
function createCssValues(obj) {
    var pixel = {};
    var integer = {};
    var key;
    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            pixel[key] = obj[key];
            integer[key] = parseInt(obj[key].replace(/"/, '').replace(/px/, ''), 10);
        }
    }
    return {
        pixel: pixel,
        integer: integer,
    };
}

/**
 * A convenience method to grab a breakpoint type
 * @param {string} type The breakpoint type: "integer" or "pixel"
 * @returns {*}
 */
function getBreakpoints(type) {
    var bp = breakpoints[type];
    var hasProps = false;
    var prop;
    if (bp) {
        for (prop in bp) {
            // just checking if object is not empty
            if (bp.hasOwnProperty(prop)) {
                hasProps = true;
                break;
            }
        }
    }
    if (!hasProps) {
        return false;
    }
    return bp;
}

/**
 * A convenience method that returns the deviceType associated
 * with the current viewport width
 * @returns {string}
 */
function getDeviceType() {
    var viewportWidth = global.document.body.getBoundingClientRect().width;
    return viewportWidth <= breakpoints.integer['tablet-portrait']
        ? 'mobile'
        : viewportWidth > breakpoints.integer['tablet-landscape'] ? 'desktop' : 'tablet';
}

// parse the px css string into a integer value
props = createCssValues(cssBreakpoints);
breakpoints.pixel = props.pixel;
breakpoints.integer = props.integer;

module.exports = {
    breakpoints: breakpoints,
    getBreakpoints: getBreakpoints,
    getDeviceType: getDeviceType,
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/core/commonjs/cssVars.js
// module id = 166
// module chunks = 62